<template>
  <m-dropdown
    block
    placement="bottomRight"
    :title="$t('gridPageChartEditor.precision')"
  >
    <m-card-item icon="decimal-places">
      {{ $t('gridPageChartEditor.precision') }}
      <template #right>
        <chart-editor-setting-value :value="optionsMap[value]?.text" />
      </template>
    </m-card-item>
    <template #overlay>
      <m-card
        no-padding
        list
      >
        <m-card-item
          v-for="option in options"
          :key="option.value"
          @click="$emit('update:value', option.value)"
        >
          {{ option.text }}
        </m-card-item>
      </m-card>
    </template>
  </m-dropdown>
</template>

<script setup>
import ChartEditorSettingValue from '@/components/custom-grid/ChartEditorSettingValue.vue';
import { gridPageChartPrecision } from 'shared/constants.json';
import { useI18n } from 'vue-i18n';

defineProps({ value: { type: String, default: gridPageChartPrecision.precisionAutomatic } });

defineEmits(['update:value']);

const { t } = useI18n();

const PRECISION_DIGIT_LABEL = {
  [gridPageChartPrecision.precision0]: '0',
  [gridPageChartPrecision.precision1]: '1',
  [gridPageChartPrecision.precision2]: '2',
  [gridPageChartPrecision.precision3]: '3',
  [gridPageChartPrecision.precision4]: '4',
  [gridPageChartPrecision.precision5]: '5',
};

const options = [
  { text: t('gridPageChartEditor.precisionAutomatic'), value: gridPageChartPrecision.precisionAutomatic },
  ...gridPageChartPrecision.all
    .filter((v) => v !== gridPageChartPrecision.precisionAutomatic)
    .map((value) => ({ text: PRECISION_DIGIT_LABEL[value], value })),
];
const optionsMap = Object.fromEntries(options.map((o) => [o.value, o]));
</script>
